import { render, staticRenderFns } from "./AcknowledgementReceiptsJournal.vue?vue&type=template&id=3e176f6c&"
import script from "./AcknowledgementReceiptsJournal.vue?vue&type=script&lang=js&"
export * from "./AcknowledgementReceiptsJournal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports